import { writable } from 'svelte/store';

let StoreFormData = {
    global_vars: {
        //stripe_account: "account_v2",
        // can be: "account_v2", "account_v3", "default"
        stripe_account: "account_v3",
        stripeTokens: { 
            live: "pk_live_ZodCkKBak1MPlwBJsxsMuubx",
            test: "pk_test_X7AvKFxbFhE5jaMPKPqiAbql003mxvgpKe",
        },
        stripeTokens_v2: { 
            live: "pk_live_51OEXyaGqoorrE7eC4Qtor2u3YWGCqZkxiPGBk9NZf7QMWCy0KBZlohfpoHaKYkWEiZMYFGWbtlP9kLSt6LRsuEPE00vwPdGIjS",
            test: "pk_test_51OEXyaGqoorrE7eCLdOu0IfVLrKTAyUZeFunq7vgyE84beauILQ1yYT1QCB2otAx3nJioglxBPsR60x4rqZP7rCB00J9IP9O7v",

            // RE-DEFINE TO USE stripeTokens from V1 for some days.
            //live: "pk_live_ZodCkKBak1MPlwBJsxsMuubx",
            //test: "pk_test_X7AvKFxbFhE5jaMPKPqiAbql003mxvgpKe",
        },
        stripeTokens_v3: { 
            live: "pk_live_51SOQ6UPWUiEzVSKLDffbxV5FDIsKEpw7lPINyGIZZc2yBUC2sKAAjY74sJSRUONrDvtlJj2rlMOkEMaoJIm840tc0050HtAGXy",
            test: "pk_test_51SP5oQPgKChwHQrspDKq5hP6g8amfoTVl1sx8JXwLJCrtl6sY7HVMO8E6sLfiPVPs7FbfWB416gHfnstK5s6i5Hq00SnLqIbPI",

            // RE-DEFINE TO USE stripeTokens from V1 for some days.
            //live: "pk_live_ZodCkKBak1MPlwBJsxsMuubx",
            //test: "pk_test_X7AvKFxbFhE5jaMPKPqiAbql003mxvgpKe",
        }

    },
    dataForm: {},
    plansFetched: [
        /*{
            "CreationDate": "2021-10-13",
            "time": "1634103576",
            "FromDB": "plans",
            "__id__": "pyji",
            "name_plan": "El funnel del dinero",
            "limit_service": "0",
            "membership_type": "funnels",
            "position_plan": "10",
            "price_plan": "25",
            "is_pexels_available": "DEACTIVATED",
            "img_plan": "https://i.ibb.co/BtZmHtz/3-Pod-Dashboard-Icons-Websites-2x.png",
            "availableCategories": "[]",
            "type": "PLAN",
            "items": "{\"El funnel del dinero\":\"El funnel del dinero\"}",
            "account_group": "",
            "unit_code": "",
            "product_name_siigo": "",
            "unit_coin": "USD",
            "comments": "",
            "doc_code": "",
            "limit_budget": "0",
            "projects_at_same_time": "1",
            "SalesmanIdentification": "",
            "stripe_plan": "stripe_plan_pyji",
            "stripe_product": "stripe_product_pyji",
            "interval_year_price": 20
        }*/
    ],
}

function storeForm() {
	const { subscribe, set, update } = writable(StoreFormData);
    const form = {
        subscribe,
        update_raw: update,
        update: function(field, dataForm, merge_with){
            merge_with = merge_with ?? null;
            update((data)=>{
                if(merge_with !== null){
                    Object.values(dataForm).map((item, key)=>{
                        let name = Object.keys(dataForm)[key];
                        merge_with[name] = item;
                    })
                    dataForm = merge_with;
                }
                

                data[field] = dataForm;
                return data;
            })
        },
    }
    return form;
}

window.StoreFormData = StoreFormData;

export const StoreForm = storeForm();